module.exports = __webpack_public_path__ + "img/top-bg.87631905.webp";